import React, { useEffect, useState } from "react";

import Bartenderimg from "../assets/images/Bar_ten_er.png";
import Aviacion from "../assets/images/Img-Carousel/Aviacion.png";
import Bartender from "../assets/images/Img-Carousel/Bartender.jpg";
import Cheff from "../assets/images/Img-Carousel/Cheff.jpg";
import Main from "../assets/images/Img-Carousel/main.png";

import AviacionP from "../assets/images/aviacion.png";
import Logo from "../assets/images/cevablanco2.png";
import ChefP from "../assets/images/cheffp.png";

export const Carousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  /* ORDEN NUEVO:
     1 Chef
     2 Bartender
     3 Aviación
     4 Main
  */
  const images = [Cheff, Bartender, Aviacion, Main];

  const img = [ChefP, Bartenderimg, AviacionP, Logo];

  const description = [
    "Maestro culinario en creación de menús innovadores y cocina profesional.",
    "Experto en mixología y cócteles artesanales exclusivos.",
    "Conviértete en tripulante de cabina y viaja por el mundo.",
    "La primera institución de turismo del país, con más de 50 años formando profesionales exitosos.",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [images.length]);

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToCareers = () => {
    const target = document.getElementById("careers");

    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="w-full h-screen relative overflow-hidden">
      <div className="relative w-full h-full">
        {images.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-700 ${
              activeIndex === index ? "opacity-100 z-20" : "opacity-0 z-10"
            }`}
          >
            {/* Imagen */}
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              className="w-full h-full object-cover"
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/200"></div>

            {/* Contenido */}
            <div className="absolute inset-0 flex items-center justify-center px-4">
              <div className="max-w-4xl w-full bg-black/40 backdrop-blur-sm rounded-3xl p-8 md:p-10 text-white text-center shadow-2xl border border-white/10">
                <img
                  src={img[index]}
                  alt="logo"
                  className="mx-auto mb-6 max-h-36 object-contain"
                />

                <div className="w-24 h-1 bg-white/70 mx-auto rounded-full mb-5"></div>

                <p className="text-lg md:text-xl text-gray-100 leading-relaxed max-w-3xl mx-auto">
                  {description[index]}
                </p>

                <div className="mt-8 flex flex-wrap gap-4 justify-center">
                  <button
                    onClick={goToCareers}
                    className="px-8 py-4 bg-blue-700 hover:bg-blue-800 rounded-full font-semibold text-lg shadow-xl transition hover:scale-105"
                  >
                    Ver Carreras
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Indicadores */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-40 flex gap-3">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`w-3 h-3 rounded-full transition ${
                activeIndex === index
                  ? "bg-white scale-125"
                  : "bg-white/40"
              }`}
            />
          ))}
        </div>

        {/* Flecha izquierda */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-40 w-12 h-12 rounded-full bg-white/20 hover:bg-white/30 text-white flex items-center justify-center backdrop-blur-md"
        >
          ❮
        </button>

        {/* Flecha derecha */}
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-40 w-12 h-12 rounded-full bg-white/20 hover:bg-white/30 text-white flex items-center justify-center backdrop-blur-md"
        >
          ❯
        </button>
      </div>
    </section>
  );
};